const mobileQuery = window.matchMedia('(max-width: 749px)');
const bars = new Set();

function onIdle(callback) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: 1200 });
    return;
  }

  window.setTimeout(callback, 250);
}

function isRecommendationBar(bar) {
  return bar.classList.contains('cp-card-scrollbar--always');
}

function shouldBind(bar) {
  return mobileQuery.matches || isRecommendationBar(bar);
}

function bindBar(bar) {
  if (bar.dataset.cpCardScrollbarBound === 'true' || !shouldBind(bar)) return;

  const gallery = bar.closest('.card-gallery');
  const scroller = gallery?.querySelector('slideshow-slides');
  const thumb = bar.querySelector('.cp-card-scrollbar__thumb');
  if (!scroller || !thumb) return;

  bar.dataset.cpCardScrollbarBound = 'true';
  bars.add({ bar, scroller, thumb, recommendation: isRecommendationBar(bar), fadeTimer: 0, frame: 0 });
}

function updateState(state, reveal) {
  if (state.frame) return;

  state.frame = window.requestAnimationFrame(() => {
    state.frame = 0;

    const scrollWidth = state.scroller.scrollWidth;
    const clientWidth = state.scroller.clientWidth;
    if (scrollWidth <= clientWidth || !clientWidth) return;

    const ratio = clientWidth / scrollWidth;
    const maxThumbTravel = clientWidth * (1 - ratio);
    const maxScroll = scrollWidth - clientWidth;

    state.thumb.style.width = `${ratio * 100}%`;
    state.thumb.style.transform = `translateX(${(state.scroller.scrollLeft / maxScroll) * maxThumbTravel}px)`;

    if (!reveal && !state.recommendation) return;

    state.bar.style.opacity = '1';
    window.clearTimeout(state.fadeTimer);
    if (!state.recommendation) {
      state.fadeTimer = window.setTimeout(() => {
        state.bar.style.opacity = '0';
      }, 2000);
    }
  });
}

function activateBar(bar) {
  bindBar(bar);
  const state = [...bars].find((item) => item.bar === bar);
  if (!state || state.bar.dataset.cpCardScrollbarActive === 'true') return;

  state.bar.dataset.cpCardScrollbarActive = 'true';
  state.scroller.addEventListener('scroll', () => updateState(state, true), { passive: true });

  if (state.recommendation) {
    onIdle(() => updateState(state, false));
  }
}

function observeBar(bar) {
  if (bar.dataset.cpCardScrollbarObserved === 'true') return;
  bar.dataset.cpCardScrollbarObserved = 'true';

  if ('IntersectionObserver' in window) {
    observer.observe(bar);
    return;
  }

  onIdle(() => activateBar(bar));
}

const observer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            activateBar(entry.target);
          });
        },
        { rootMargin: '300px 0px' }
      )
    : null;

function scan(root = document) {
  root.querySelectorAll('[data-cp-card-scrollbar]').forEach(observeBar);
}

mobileQuery.addEventListener('change', () => {
  document.querySelectorAll('[data-cp-card-scrollbar]').forEach((bar) => {
    if (bar.dataset.cpCardScrollbarBound === 'true') return;

    delete bar.dataset.cpCardScrollbarObserved;
    observeBar(bar);
  });
});

window.addEventListener(
  'resize',
  () => {
    bars.forEach((state) => updateState(state, false));
  },
  { passive: true }
);

scan();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      if (node.matches('[data-cp-card-scrollbar]')) {
        observeBar(node);
        return;
      }

      scan(node);
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });
